import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';

@Injectable()
export class PetroLimsAuthGuard implements CanActivate {

  constructor(private router: Router) {
  }
  canActivate(userRole) {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (localStorage.getItem('currentUser') && currentUser.RoleId != undefined && currentUser.RoleId != null && currentUser.RoleId != '') {
      let data=userRole.data.roles;
      for (var i = 0; i < data.length; i++) {
        if (data[i] == currentUser.RoleId) {
          return true;
        }
      }
      this.router.navigate(['/login']);
      return false;
    }
  }
}
